module.exports = __webpack_public_path__ + "static/black@2x-4dd2bb3837ac2ff69ac7d3c2d8f36608.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/black@2x.png
// module id = 2597
// module chunks = 168707334958949